<template>
  <a-spin :spinning="formOption.busy">

    <a-form :form="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
    >
      <div class="form_title">奖项设置</div>

    </a-form>
    <roleTable ref="roleTable"></roleTable>
    <a-space class="a-form-btn-box">
      <a-button @click="lastStep">上一步</a-button>
      <a-button type="primary" @click="submit">下一步</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin, fmt} from '@/utils/common/FormBase'
import {dataApi} from "@/services/market/active";
import roleTable from './roleTable'

/**
 * 加载规则 必填控制我
 */
function getRulesTemplate() {
  return {};
}


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    isAutoTag: true
  };
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {

  let entity = await dataApi.getFormDetail(rowId);
  this.$refs['roleTable'].loadData(entity.data.prizeList);
  return fmt.formatFormLoad(entity);
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
async function afterLoad() {
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function submit() {
  const vm = this
  let entities = {}
  vm.$refs["roleTable"].getChildData((child, del) => {
    entities.addPrizeList = child;
    entities.delPrizeList = del.map(item => {
      return item.prizeId
    });
  });
  if (entities.addPrizeList.length === 0) {
    this.$message.error('请添加一个奖品')
    return false
  }
  entities.actId = vm.rowId
  await dataApi.saveFormDetail(entities).then(res => {
    if (res.code === 200) {
      this.$emit('nextStep', res.data.actId)
    } else {
      this.$message.error(res.msg)
    }
  })
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {roleTable},
  data() {
    return {
      index: 0,
      list: [{}]
    }
  },
  mounted() {
    console.log(this.rowId)
    // 切换页面时滚动条自动滚动到顶部
    window.scrollTo(0, 0);
  },
  methods: {
    loadEntity,
    newEntity,
    submit,
    getRulesTemplate,
    afterLoad,
    loadBaseData,
    add() {
      const item = {}
      this.list.splice(this.index + 1, 0, item)
    },
    delItem() {
      if (this.list.length <= 1) {
        this.$message.error('请至少填写一条奖项')
        return false
      }
      this.list.splice(this.index, 1)
    },
    lastStep() {
      this.$emit('lastStep')
    },
    handleChange() {
      this.$forceUpdate()
    }
  }
};
</script>
<style lang="less" scoped>
.hd {
  margin-bottom: 24px;

  i {
    font-size: 24px;
    margin-left: 12px;
    color: #D90B18;
    cursor: pointer;
  }
}
</style>
